import $ from 'jquery'
import {
    getEmailVerified,
    setEmailVerified,
    confirmEmailVerified,
    nextModalOpenVar,
    openModalOnce,
    callDatalayer,
    showUpsellFixedBanner,
    nextModalOpenVarData,
    userIsVerified,
} from "./module_common.js";

import * as Sentry from "@sentry/browser";

import Cookies from 'js-cookie'

import { openResendEmail, sendVerificationEmail } from './module_checkout_helper'
import { openSignInModal, setPreCompletionFn } from './module_auth_helper'
import { openModal } from './module_modal'

let checkModalOpen = true;
let checkOnlyModalGuestOpen = false;

function enableLinksInCheckboxes() {
    $(document).on("tap click", 'label span a', function (event, data) {
        event.stopPropagation();
        event.preventDefault();
        window.open($(this).attr('href'), $(this).attr('target'));
        return false;
    });
}

// use this funcion before doLast()
export function disableModalOpenCheck(){
    checkModalOpen = false
}

export function checkOnlyGuestModal(){
    checkOnlyModalGuestOpen = true
}

const setRedirection = function(elem, url) {
    $(elem).click(function(){
        window.location.href = url;
    })
}

const parseOP = function(operations){
    operations.forEach(function(op){
        if (op["fn"] === "setRedir") {
            setRedirection(op["el"], op["url"]);
        }
    });
}

function isEmailAlredyVerified(notifyApiEmailVerified) {
    const data = getEmailVerified()
    if (!data) return false
    return data.uid === notifyApiEmailVerified.uid && data.code === notifyApiEmailVerified.code
}

// reload page after login+redirect, when user use browser back button
function reloadBrowserBack(){
    // call both on page load and after a browser back button
    window.addEventListener('pageshow', function (event) {
        const mrob = sessionStorage.getItem("mustReloadOnBack")
        if (!mrob) return

        // check if the page is load from a browser back button
        // the topic is not easy.. see https://github.com/GoogleChrome/web-vitals/issues/393
        const back = performance && 
        performance.getEntriesByType("navigation") &&
        performance.getEntriesByType("navigation")[0] && 
        performance.getEntriesByType("navigation")[0].type === 'back_forward'

        // event.persisted -> Indicates if the document is loading from a cache
        // performance.getEntriesByType("navigation") is a PerformanceEntry of type PerformanceNavigationTiming

        const comeFromBackButton = event.persisted || back
        if (comeFromBackButton && mrob == location.href) {
            sessionStorage.removeItem("mustReloadOnBack")
            location.reload()    
        }
    });
}

class UnhandledPromiseRejection extends Error{
    constructor(...params) {
        super(...params);
        this.name = "UnhandledPromiseRejectionV2"
    }
}

function createFingerprint(str) {
  if (!str) return ""
  // first 10 chars
  let fingerpr = str.slice(0, 10);
  // space remove
  return fingerpr.replace(/\s/g, "");
}

function handleUnhandledrejection(){
    // Sentry will capture original unhandledrejection unless we disable it in Sentry.init
    // if we don't disable it, with this code we send ANOTHER error
    window.addEventListener("unhandledrejection", (event) => {
        // console.log("Promise:", event.promise);
        // console.log("Motivo:", event.reason);

        // simulate unhandledrejection Error: Promise.reject(new Error("Simulated unhandledrejection"))
        // simulate unhandledrejection non-Error: Promise.reject(42)

        if (event.reason === undefined) return

        let origErr

        if (event.reason instanceof Error) {
            origErr = event.reason;
        } else {
            try {
                const reason = JSON.stringify(event.reason);
                origErr = new Error("Promise rejection non-Error: " + reason)
            } catch {
                origErr = new Error("Promise rejection non-Error, unserializable")
            }
        }

        const context = {}
        const fingerprint = createFingerprint(origErr.message)
        if (fingerprint) context.fingerprint = [fingerprint]
        const err = new UnhandledPromiseRejection("Unhandled promise rejection error", {"cause": origErr})
        Sentry.captureException(err, context)
    });
}

export function checkAndConfirmEmail(){
    if (new URLSearchParams(window.location.search).get('error')) return
    if (typeof notifyApiEmailVerified !== "undefined"){
        if (isEmailAlredyVerified(notifyApiEmailVerified)) return
        setEmailVerified(notifyApiEmailVerified)
        confirmEmailVerified(notifyApiEmailVerified);
    }
}

const RESENDABLE_VERIFY_ERRORS = ['expired', 'invalid']

export function checkEmailVerificationError(){
    const params = new URLSearchParams(window.location.search)
    const error = params.get('error')
    if (!error) return

    const uid = params.get('uid')
    const vc = params.get('vc')

    if (RESENDABLE_VERIFY_ERRORS.includes(error) && uid && vc){
        if (UIDg){
            if (!userIsVerified){
                openResendEmail(uid, vc, false)
            }
        }else{
            $("#loginresend").on("click", function(){
                setPreCompletionFn((data) => {
                    if (!data.verified){
                        sendVerificationEmail(uid, vc, false)
                    }
                })
                openSignInModal()
            })
            openModal("#loginToResendEmailModal", "checkEmailVerificationError")
        }
        return
    }

    openModal("#requestProblemTryLogoutModal", "checkEmailVerificationError")
}

export function doLast(){

    handleUnhandledrejection()

    reloadBrowserBack()

    enableLinksInCheckboxes();

    if (UIDg){
        const dEvent = {
            'event':'intercomEvent',
            'email': UEM,
            'userId': UIDg,
            'name': Unm,
            'isPremium': UiP,
            'signupDate': UsgnD,
        }
        dataLayer.push(dEvent)
    }

    // ?? not used anymore?
    if (__OP.length > 0) {
        parseOP(__OP);
    }

    checkAndConfirmEmail()
    checkEmailVerificationError()

    if (checkModalOpen){
        if (checkOnlyModalGuestOpen){
            // this operation clear nextModalOpenVar cookie
            const openMod = Cookies.get(nextModalOpenVar);
            if (openMod == 'CongratsGuestModal') {
                openModalOnce()
            }else{
                Cookies.remove(nextModalOpenVar)
                Cookies.remove(nextModalOpenVarData)
            }

        }else{
            // this operation clear nextModalOpenVar cookie
            const openMod = Cookies.get(nextModalOpenVar);
            if (openMod) {
                openModalOnce()
            }
        }
    }

    callDatalayer();

    // not used anymore
    if (typeof showUpsellBanner !== "undefined") {
        showUpsellFixedBanner();
    }
}
